import { useEffect } from 'react';
import { config } from '@xingternal/hops';
import { dispatchableFetch } from '@xingternal/hops-redux';
import { useDispatch } from 'react-redux';
import { loadingFeaturesEnd, loadingFeaturesStart } from '../contact/state/actions';

const { apiBaseUrl } = config;

// TODO: Don't know if we should really use dispatchableFetch anymore tbh.
const fetchFeaturesAction = dispatchableFetch({
  url: `${apiBaseUrl}/features`,
  headers: {
    'Content-Type': 'application/json',
  },
  onStart: loadingFeaturesStart,
  onSuccess: loadingFeaturesEnd,
  onError: (e) => {
    // If this happens, the user will see that the feature is disabled
    // No need to show another error message for the API call or something similar.
    return console.error(e); // eslint-disable-line
  },
});

const useFeatures = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchFeaturesAction);
  }, []);
};

export default useFeatures;
